import styled from 'styled-components'
import {media} from '../../theme/config'

export const CartButton = styled.button`
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  height: 36px;
  padding: 0;
  font-size: ${props => props.theme.typography.fontSize.fs3};
  min-width: 36px;
  margin-left: ${({noMargin}) => (noMargin ? '0' : '15px')};
  border-radius: 3px;
  border: none;
  font-weight: 700;
  font-family: ${props => props.theme.typography.fontFamilies.ff1};
  background: ${props => props.theme.colors.secondary.gradient};
  color: ${props => props.theme.colors.greyscale.white};
  cursor: pointer;
  text-decoration: none;
  
  &:hover{
    background: ${props => props.theme.colors.secondary.base}; 
    color: ${props => props.theme.colors.greyscale.white};
  }
  
  @media ${media.mobileL} {
    height: 46px;
    min-width: 46px;
  }
  @media ${media.tablet} {
    min-width: 222px;
    margin-left: 30px;
    
    i {
      vertical-align: middle;
      margin-right: 5px;
    }
  }
`

export const CartLink = CartButton.withComponent('a')

export const CartButtonCount = styled.span`
  position: absolute;
  text-align: center;
  border-radius: 100%;
  top: 0;
  right: 0;
  line-height: 20px;
  height: 20px;
  width: 20px;
  display: block;
  color: ${props => props.theme.colors.greyscale.white};
  background: ${props => props.theme.colors.accents.error};
  padding: .3 rem;
  transform: translate(5px, -5px);
  
  @media ${media.mobileL} {
    height: 24px;
    width: 24px;
    line-height: 24px;
  }
`
